<template>
    <Icon
        class="CIcon"
        :name="iconName"
        :title="title"
        :height="undefinedSize ? '100%' : realSize"
        :width="undefinedSize ? '100%' : realSize"
    ></Icon>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const knownSizes = {
    large: 48,
    normal: 24,
    small: 16,
    xsmall: 12
} as const

type SizeKey = keyof typeof knownSizes
type PropSize = number | SizeKey

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    title: {
        type: String,
        default: undefined
    },
    size: {
        type: [Number, String] as PropType<PropSize>,
        default: 'normal',
        validator: (value: unknown) =>
            typeof value === 'number' || ['large', 'normal', 'small', 'xsmall'].includes(value as SizeKey)
    },
    undefinedSize: {
        type: Boolean,
        default: false
    }
})

// Our own icons live in app/assets/icons (the `growni` collection). A name that already has a
// collection, like `heroicons:folder`, goes to @nuxt/icon as is: prefixing it would make Iconify
// read `growni` as an API provider and render nothing.
const iconName = computed(() => (props.name.includes(':') ? props.name : `growni:${props.name}`))

const realSize = computed(() => {
    const sizeValue = typeof props.size === 'number' ? props.size : knownSizes[props.size as SizeKey]
    return String(sizeValue || knownSizes.normal)
})
</script>

